import { tabIcons, tabTemplate } from '@/layout/state/state';
import { matchSingleUrl, relativeUrl } from '@/constants/urls';
import HomePanel from '../components/HomePanel';

export default {
  ...tabTemplate('home', HomePanel, [/^\/?$/, /^\/?data\/?$/, /^\/?tab\/?$/, ...matchSingleUrl(['home'])]),
  ...tabIcons('home'),
  componentState: () => ({ url: relativeUrl('home') }),
  order: 1,
};
